<template>
  <div class="container-table">
    <!-- <span>{{ tituloTabela }}</span> -->

    <table>
      <thead>
        <tr>
          <th>COMPONENTE</th>
          <th>VALOR</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>
            Equidade
            <span v-if="equipesEquidade"> ({{ equipesEquidade }}) </span>
          </td>
          <td class="text-center">
            {{ formatCurrency(valorFixoCusteio) }}
          </td>
        </tr>

        <tr>
          <td>
            Vínculo e acompanhamento
            <span v-if="equipesCVAT"> ({{ equipesCVAT }}) </span>
          </td>
          <td class="text-center">
            {{ formatCurrency(valorVinculoAcompanhamento) }}
          </td>
        </tr>

        <tr>
          <td>
            Qualidade
            <span v-if="equipesQualidade"> ({{ equipesQualidade }}) </span>
          </td>
          <td class="text-center">
            {{ formatCurrency(valorQualidade) }}
          </td>
        </tr>

        <tr>
          <td>Per capita</td>
          <td class="text-center">
            {{ formatCurrency(valorPerCapita) }}
          </td>
        </tr>

        <tr class="grey">
          <td><strong>Total</strong></td>
          <td class="text-center">
            <strong>{{ formatCurrency(valorTotal) }}</strong>
          </td>
        </tr>
      </tbody>
    </table>

    <span class="fonte" v-html="fonte"></span>
  </div>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
      default: '',
    },
    numeroQuadro: {
      type: String,
      default: '',
    },
    classificacao: {
      type: String,
      default: '',
    },
    fixo: {
      type: Object,
      default: () => ({
        valorImplantacao: 0,
        valorCusteio: 0,
      }),
    },
    vinculoAcompanhamento: {
      type: Number,
      default: 0,
    },
    qualidade: {
      type: Number,
      default: 0,
    },
    perCapita: {
      type: Number,
      default: 0,
    },
    fonte: {
      type: String,
      default: '',
    },
    dados: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    /**
     * Retorna o título da tabela.
     *
     * @returns {String}
     */
    tituloTabela() {
      if (this.titulo) {
        return this.titulo
      }

      if (this.numeroQuadro && this.classificacao) {
        return `Quadro ${
          this.numeroQuadro
        } - Valores por componente na hipótese de desempenho municipal "${this.classificacao.toUpperCase()}"`
      }

      return 'Valores por componente'
    },

    /**
     * Retorna o valor fixo de custeio.
     *
     * @returns {Number}
     */
    valorFixoCusteio() {
      return Number(this.fixo?.valorCusteio || 0)
    },

    /**
     * Retorna o valor do vínculo e acompanhamento.
     *
     * @returns {Number}
     */
    valorVinculoAcompanhamento() {
      return Number(this.vinculoAcompanhamento || 0)
    },

    /**
     * Retorna o valor da qualidade.
     *
     * @returns {Number}
     */
    valorQualidade() {
      return Number(this.qualidade || 0)
    },

    /**
     * Retorna o valor per capita.
     *
     * @returns {Number}
     */
    valorPerCapita() {
      return Number(this.perCapita || 0)
    },

    /**
     * Retorna o valor total da tabela.
     *
     * @returns {Number}
     */
    valorTotal() {
      return (
        this.valorFixoCusteio +
        this.valorVinculoAcompanhamento +
        this.valorQualidade +
        this.valorPerCapita
      )
    },

    /**
     * Retorna as equipes da Equidade.
     *
     * @returns {String}
     */
    equipesEquidade() {
      const totais = this.dados?.etapa4?.totaisEquipes || {}

      return [
        `${Number(totais['eSF'] || 0)} eSF`,
        `${Number(totais['eAP 20h'] || 0)} eAP 20h`,
        `${Number(totais['eAP 30h'] || 0)} eAP 30h`,
      ].join(', ')
    },

    /**
     * Retorna as equipes do CVAT.
     *
     * @returns {String}
     */
    equipesCVAT() {
      const equipes = this.dados?.etapa4?.equipes || []

      const labels = ['eSF', 'eSFR', 'eAP 20h', 'eAP 30h']

      return labels
        .map((label) => {
          const quantidade = equipes
            .filter((item) => {
              return item.componente === 'CVAT' && item.equipe === label
            })
            .reduce((total, item) => {
              return total + Number(item.quantidade || 0)
            }, 0)

          return `${quantidade} ${label}`
        })
        .join(', ')
    },

    /**
     * Retorna as equipes da Qualidade.
     *
     * @returns {String}
     */
    equipesQualidade() {
      const equipes = this.dados?.etapa4?.equipes || []

      const labels = ['eSF', 'eSFR', 'eAP', 'eSB', 'eMulti', 'eCR', 'eAPP']

      return labels
        .map((label) => {
          let quantidade = 0

          if (label === 'eAP') {
            quantidade = equipes
              .filter((item) => {
                return (
                  item.componente === 'eAP' &&
                  ['eAP 20h', 'eAP 30h'].includes(item.equipe)
                )
              })
              .reduce((total, item) => {
                return total + Number(item.quantidade || 0)
              }, 0)
          } else {
            quantidade = equipes
              .filter((item) => {
                return item.componente === label
              })
              .reduce((total, item) => {
                return total + Number(item.quantidade || 0)
              }, 0)
          }

          return `${quantidade} ${label}`
        })
        .join(', ')
    },
  },

  methods: {
    /**
     * Formata um valor em moeda brasileira.
     *
     * @param {Number} value
     * @returns {String}
     */
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(Number(value || 0))
    },
  },
}
</script>
<style lang="scss" scoped>
.container-table {
  @media print {
    margin-bottom: 15px;
  }
  @media screen and (max-width: 1024px) {
    overflow: scroll;
  }
  span {
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }
  table {
    width: 100%;
    border: 1px solid;
    border-collapse: collapse;

    th {
      border: 1px solid black;
      text-align: center;
    }
    td {
      border: 1px solid black;
      padding: 10px;
    }
  }
}
</style>
<style lang="scss"></style>
